/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billed_AnnuallyInputs */

const en_billed_annually = /** @type {(inputs: Billed_AnnuallyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Billed annually`)
};

const es_billed_annually = /** @type {(inputs: Billed_AnnuallyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Facturado anualmente`)
};

const fr_billed_annually = /** @type {(inputs: Billed_AnnuallyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Facturé annuellement`)
};

const de_billed_annually = /** @type {(inputs: Billed_AnnuallyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jährlich abgerechnet`)
};

const ja_billed_annually = /** @type {(inputs: Billed_AnnuallyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`年次請求`)
};

const zh_billed_annually = /** @type {(inputs: Billed_AnnuallyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`按年计费`)
};

const ar_billed_annually = /** @type {(inputs: Billed_AnnuallyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تُدفع سنوياً`)
};

const id_billed_annually = /** @type {(inputs: Billed_AnnuallyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ditagih secara tahunan`)
};

const it_billed_annually = /** @type {(inputs: Billed_AnnuallyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fatturato annualmente`)
};

const ru_billed_annually = /** @type {(inputs: Billed_AnnuallyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Оплачивается ежегодно`)
};

const pt_billed_annually = /** @type {(inputs: Billed_AnnuallyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cobrado anualmente`)
};

const ko_billed_annually = /** @type {(inputs: Billed_AnnuallyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`연간 청구됨`)
};

/**
* | output |
* | --- |
* | "Billed annually" |
*
* @param {Billed_AnnuallyInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const billed_annually = /** @type {((inputs?: Billed_AnnuallyInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billed_AnnuallyInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_billed_annually(inputs)
	if (locale === "es") return es_billed_annually(inputs)
	if (locale === "fr") return fr_billed_annually(inputs)
	if (locale === "de") return de_billed_annually(inputs)
	if (locale === "ja") return ja_billed_annually(inputs)
	if (locale === "zh") return zh_billed_annually(inputs)
	if (locale === "ar") return ar_billed_annually(inputs)
	if (locale === "id") return id_billed_annually(inputs)
	if (locale === "it") return it_billed_annually(inputs)
	if (locale === "ru") return ru_billed_annually(inputs)
	if (locale === "pt") return pt_billed_annually(inputs)
	return ko_billed_annually(inputs)
});